<template>
  <label :class="{ 'has-error': hasError }">
    <slot name="label"></slot>

    <input
      v-model="input"
      v-bind="$attrs"
      v-on="listeners"
      :class="classes"
      v-if="!multipleLines">

    <textarea
      v-else
      :class="classes"
      v-model="input"
      v-bind="$attrs"
      v-on="listeners"
      cols="30" rows="5"></textarea>

    <div class="error">
      {{ messageError }}
    </div>
  </label>
</template>

<script>
export default {
  name: 'VTextField',
  inheritAttrs: false,
  props: {
    value: {
      required: true
    },
    multipleLines: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    messageError: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    input: ''
  }),
  mounted () {
    this.input = this.value
  },
  computed: {
    classes () {
      let classes = 'text-field'
      if (this.block) {
        classes += ' text-field--block'
      }
      return classes
    },
    listeners () {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event.target.value)
      }
    }
  },
  watch: {
    value () {
      this.input = this.value
    }
  }
}
</script>

<style lang="stylus" scoped>
  label
    display block
    position relative
    color #222
    font-size 12px
    text-transform uppercase

    .text-field
      border-width 1px
      border-style solid
      border-color #d4d4d4
      padding 10.5px 55px 10.5px 20px
      border-radius 5px
      transition border-color ease-in-out .3s
      color #222
      margin-top 3px
      font-size 14px
      text-transform none
      resize none

      &:focus
        border-color #858585
        outline none

      &--block
        display block
        width 100%

    .error
      position absolute
      width 100%
      top calc(100% + 1px)
      text-align left
      font-size 12px
      color #ff1744
      display none
      text-transform none

    &.has-error
      color #ff1744

      .text-field
        border-color #ff1744

      .error
        display block
</style>



// WEBPACK FOOTER //
// VTextField.vue?ea05491e